export default __webpack_public_path__ + "media/zurb/img/events/wired/raft/raft-4-aeab6e54cbecbd747db742a6e1f15cc7.png";